import PropTypes from 'prop-types';
import { OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorsAndWarningsTooltipHeader = ({
  iconColor,
  langKey
}) => /*#__PURE__*/_jsxs("span", {
  className: "is--heading-7",
  style: {
    color: OBSIDIAN
  },
  children: [/*#__PURE__*/_jsx(UIIconCircle, {
    backgroundColor: iconColor,
    borderWidth: 0,
    className: "m-right-2",
    color: OLAF,
    name: "warning",
    padding: 0.25
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey
  })]
});
ErrorsAndWarningsTooltipHeader.propTypes = {
  iconColor: PropTypes.string.isRequired,
  langKey: PropTypes.string.isRequired
};
export default ErrorsAndWarningsTooltipHeader;